import { Field, reduxForm, initialize } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import { connect } from 'react-redux'
import REGEXP from 'constant/REGEXP'
import FontAwesome from 'react-fontawesome'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'
import { getGMAPAddressComponents, formatAddress } from 'common/helpers'

const validate = values => {
    const errors = {}
    if (values.email && !REGEXP.validations.email.test(values.email))
        errors.email = 'Need a valid email.'

    for (const key in values) {
        if (key.match('email') && values[key] && !REGEXP.validations.email.test(values[key]))
            errors[key] = 'Need a valid email.'
    }
    return errors
}

class ClientEmail extends Component {
    constructor(props) {
        super(props)
        this.state = {
          address: formatAddress(props.client),
          client: props.client._id,
          center: {
              lat: null,
              lng: null
          },
          emails: props.client.emails && props.client.emails[0] ? props.client.emails : ['']
        }
        this.onAddressChange = this.onAddressChange.bind(this)
        this.onAddressSelect = this.onAddressSelect.bind(this)
        this.addEmail = this.addEmail.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.client._id !== this.props.client._id) {
            const initialValues = { ...nextProps.client }
            nextProps.client.emails && nextProps.client.emails.forEach((email, index) => {
                initialValues[`email${index}`] = email
            })
            this.props.dispatch(initialize('client', initialValues))
            const emails = nextProps.client.emails && nextProps.client.emails[0] ? nextProps.client.emails : ['']
            this.setState({ emails })
        }
    }

    onAddressChange(address) {
      this.setState({ address })
    }

    onAddressSelect(address) {
        geocodeByAddress(address, (err, center, results) => {
            if (err) return
            this.setState({ center })
            const location = results && results[0] ? getGMAPAddressComponents(results[0].address_components) : {}
            location.lat = center.lat
            location.lng = center.lng
            this.props.change('address', location)
            this.setState({ address })
        })
    }

    addEmail() {
        this.setState({ emails: [...this.state.emails, ''] })
    }

    render() {
        const { handleSubmit } = this.props
        const classNames = {
            input: 'content-editable',
            root: 'inline-block input'
        }
        console.log(this.state.emails)
        return (
            <form 
                onSubmit={ handleSubmit } 
                className='inline-block m-b-0'
                style={ { width: '90%' } }
                autoComplete='off'
            >
              <button className='btn btn-success btn-xs waves-effect pull-right' type='submit' disabled={ this.props.pristine }>
                  Sauver
              </button>
              <h2 className='page-title' style={ { lineHeight: '20px' } }>
                <Field
                  name='name'
                  component={ InputField }
                  type='text'
                  placeholder='Name...'
                  className='content-editable'
                  containerClassName='ce'
                  divClass='ce'
                  autoComplete='off'
                />
              </h2>
              {
                  this.state.emails.map((email, index) =>
                    <div
                        key={ index }
                    >
                        <FontAwesome name='envelope-o' />
                        <Field
                            name={ `email${index}` } 
                            component={ InputField } 
                            type='text' 
                            placeholder='Email...' 
                            className='content-editable' 
                            divClass={ 'inline-flex input' }
                            autoComplete='off'
                            defaultValue={ email }
                        />
                    </div>
                )
              }
              <div>
                    <small>
                        <a
                            onClick={ this.addEmail }
                        >
                            <FontAwesome name='plus' /> Ajouter un email
                        </a>
                    </small>
              </div>
              <div className='relative h5'>
                    <FontAwesome name='map-marker' style={{ marginRight: 15 }}/>
                    <PlacesAutocomplete
                      onChange={ this.onAddressChange.bind(this) }
                      onSelect={ this.onAddressSelect.bind(this) }
                      value={ this.state.address }
                      classNames={ classNames }
                      autoComplete={ false }
                    />
                </div>
            </form>
        )
    }
}

ClientEmail.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

ClientEmail = reduxForm({
    form: 'client',
    validate
})(ClientEmail)

const mapStateToProps = (state, props) => {
    const initialValues = state.client.current
    state.client.current.emails && state.client.current.emails.forEach((email, index) => {
        initialValues[`email${index}`] = email
    })
    return {
        initialValues,
        client: state.client.current
    }
}

export default connect(mapStateToProps)(ClientEmail)


// WEBPACK FOOTER //
// ./src/client/features/client/components/ClientForm.jsx